import { render, staticRenderFns } from "./SharedByEmployeesTopCard.vue?vue&type=template&id=01e03524&"
import script from "./SharedByEmployeesTopCard.vue?vue&type=script&lang=ts&"
export * from "./SharedByEmployeesTopCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports